import {
  GET_RECORDS,
  GET_RECORDS_SUCCESS,
  GET_RECORDS_ERROR,
  GET_DROPDOWN_SEARCH_LIST,
  GET_DROPDOWN_SEARCH_LIST_SUCCESS,
  UPDATE_SELECTED_RECORDS,
  UPDATE_FILTER,
  GET_GA_RECORDS,
  GET_GA_RECORDS_SUCCESS,
  GET_GA_RECORDS_ERROR,
  UPDATE_RECORD_LISTING_STATE,
  GET_CHILD_RECORDS,
  GET_CHILD_RECORDS_SUCCESS,
  GET_CHILD_RECORDS_ERROR
} from "../actions";

export const getSearchList = (searchRecordType, searchText, param, searchInputName, parentRecordId, activityInfo) => ({
  type: GET_DROPDOWN_SEARCH_LIST,
  payload: { searchRecordType, searchText, param, searchInputName, parentRecordId, activityInfo },
});

export const getSearchListSuccess = (searchResult) => ({
  type: GET_DROPDOWN_SEARCH_LIST_SUCCESS,
  payload: searchResult,
});

export const getRecords = (recordType, pageNumber, displayStatus, parentRecordId, selectedFilters, vocabularyId, hasUserAccount, profile, params, searchInputName, verbType, activityInfo) => ({
  type: GET_RECORDS,
  payload: { recordType, pageNumber, displayStatus, parentRecordId, selectedFilters, vocabularyId, hasUserAccount, profile, params, searchInputName, verbType, activityInfo },
});

export const getGARecords = (pageNumber) => ({
  type: GET_GA_RECORDS,
  payload: { pageNumber },
});

export const getGARecordsSuccess = (recordGAList) => ({
  type: GET_GA_RECORDS_SUCCESS,
  payload: recordGAList,
});

export const getGARecordsError = (message) => ({
  type: GET_GA_RECORDS_ERROR,
  payload: { message },
});

export const getRecordsSuccess = (recordList) => ({
  type: GET_RECORDS_SUCCESS,
  payload: recordList,
});

export const getRecordsError = (message) => ({
  type: GET_RECORDS_ERROR,
  payload: { message },
});

export const updateSelectedRecords = (recordList) => ({
  type: UPDATE_SELECTED_RECORDS,
  payload: { recordList },
});

export const updateFilter = (filter) => ({
  type: UPDATE_FILTER,
  payload: { filter },
});

export const updaterRecordListingState = (newState) => {
  return {
    type: UPDATE_RECORD_LISTING_STATE,
    payload: newState,
  };
};

export const getChildRecords = (recordType, pageNumber, displayStatus, parentRecordId, selectedFilters, vocabularyId, hasUserAccount, profile, params, searchInputName, verbType, activityInfo) => ({
  type: GET_CHILD_RECORDS,
  payload: { recordType, pageNumber, displayStatus, parentRecordId, selectedFilters, vocabularyId, hasUserAccount, profile, params, searchInputName, verbType, activityInfo },
});

export const getChildRecordsSuccess = (recordList) => ({
  type: GET_CHILD_RECORDS_SUCCESS,
  payload: recordList,
});

export const getChildRecordsError = (message) => ({
  type: GET_CHILD_RECORDS_ERROR,
  payload: { message },
});